/**
 * Admin Panel Header Component
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { RefreshCw, LogOut } from 'lucide-react';
import axios from 'axios';

// Use current origin for API calls
const API = `${window.location.origin}/api`;

export const AdminHeader = ({ userRole, activeTab, onRefresh }) => {
  const navigate = useNavigate();

  const getRoleLabel = () => {
    switch (userRole) {
      case 'admin': return 'Full Access';
      case 'design_reviewer': return 'Design Reviewer';
      case 'qa': return 'QA Tester';
      default: return 'Team Member';
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      localStorage.removeItem('session_token');
      delete axios.defaults.headers.common['Authorization'];
      navigate('/');
    } catch (err) {
      localStorage.removeItem('session_token');
      delete axios.defaults.headers.common['Authorization'];
      navigate('/');
    }
  };

  return (
    <header className="px-6 py-3 bg-white border-b border-zinc-200">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <div>
          <h1 className="text-base font-bold text-zinc-900" style={{fontFamily: 'Outfit'}}>Admin Panel</h1>
          <p className="text-xs text-zinc-500">{getRoleLabel()}</p>
        </div>
        <div className="flex items-center gap-2">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onRefresh}
            className="border-amber-300 text-amber-700 hover:bg-amber-50"
          >
            <RefreshCw className="w-4 h-4 mr-2" /> Refresh
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleLogout}
            className="border-zinc-300 text-zinc-700 hover:bg-zinc-50"
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
